import React from 'react';
import { connect } from 'react-redux'

class AddressContainer extends React.Component {
  render() {
    const { address, payment_method_name, payment_method_image } = this.props
    return (
      <div className="PaymentBox">
        <div className="FormGroup">
          <div className="suggestion">
            <span className="warning"><p>Final Reminder</p></span>
            <span className="warn">Do not send 'Ether' from an exchange</span>
          </div>
        </div>
        <iframe width="560" height="315" src="https://www.youtube.com/embed/uMPuc0-N_2Q" frameborder="0" allowfullscreen></iframe>
        <div className="PaymentAddress">
          indorse.eth
        </div>
        <div className="PaymentHelper">
          <ul>
            <li>Send your Ether to indorse.eth, our official ethereum name service (ENS) address. It will resolve to the actual contract address in your ENS compatible wallet</li>
            <li>You can confirm the full contract address at https://etherscan.io/address/indorse.eth </li>
            <li>Minimum amount is 0.05 Ether per transaction.</li>
            <li>Set Gas Limit at 250,000.</li>
            <li>Maximum contribution per ETH account is 1,000 ether (through one or a combination of multiple transactions). Any transaction which puts the account over 1,000ether  will be rejected and you will lose your gas. EG, 100+800+100 is ok, 100+800+200, last 200 will be rejected.</li>
            <li>Maximum gas fee accepted is 50,000,000,000 Wei (50 Gwei). If you use a higher fee than allowed the transaction will be rejected and you will lose your gas.</li>
            <li>Please use an ERC20 capable wallet to send the ether as this is the address the IND tokens will be sent to when issued. We suggest using MyEtherWallet as it is both ERC20 and ENS compatible</li>
          </ul>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { registrations } = state
  const { address, payment_method_name, payment_method_image } = registrations
  return { address, payment_method_name, payment_method_image }
}

export default connect(
  mapStateToProps,
  {  }
)(AddressContainer)

43,767.818



// WEBPACK FOOTER //
// ./src/containers/AddressContainer.js